import { FIELDS_KEYS } from '_constants/forms';
import {
  validateAddress,
  validateEmail,
  validateCardNumber,
  validateCVC,
  validateCardMonth,
  validateCardYear,
  validatePhone,
  validateSSN,
  validateLLCLegalName,
  validateTradeName,
  validateAltCompanyName,
  validateProductDescription,
  validateFile,
  validateDriverLicenceOrID,
  validateFullName,
} from './validators';

export const RULES = {
  [FIELDS_KEYS.processingOption]: () => {
    return {
      required: 'Please choose a Package',
    };
  },
  [FIELDS_KEYS.representativeFirstName]: () => {
    return {
      required: 'Please provide First Name',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z\\&-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Firs Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'First Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.representativeMiddleName]: () => {
    return {
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z\\&-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Middle Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Middle Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.representativeLastName]: () => {
    return {
      required: 'Please provide Last Name',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z\\&-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Last Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Last Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.representativeTitle]: () => {
    return {
      required: 'Please select a valid title',
    };
  },
  [FIELDS_KEYS.customerFirstName]: () => {
    return {
      required: 'Please provide First Name',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z\\&-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Firs Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'First Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.customerMiddleName]: () => {
    return {
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z\\&-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Middle Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Middle Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.customerLastName]: () => {
    return {
      required: 'Please provide Last Name',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z\\&-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Last Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Last Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.customerPhone]: (options) => {
    return {
      required: 'Please provide Phone number',
      validate: validatePhone(options),
    };
  },
  [FIELDS_KEYS.customerEmail]: (options) => {
    return {
      required: 'Please provide Email',
      pattern: {
        value:
          /^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\+\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i,
        message: 'Email address is not valid',
      },
      validate: validateEmail(options),
    };
  },
  [FIELDS_KEYS.fullName]: (options) => {
    return {
      required: 'Please provide Full Name',
      maxLength: {
        value: 90,
        message: 'Full Name should be less or equal 90 symbols',
      },
      validate: validateFullName(options),
    };
  },
  [FIELDS_KEYS.email]: (options) => {
    return {
      required: 'Please provide Email',
      pattern: {
        value:
          /^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i,
        message: 'Email address is not valid',
      },
      validate: validateEmail(options),
    };
  },
  [FIELDS_KEYS.subject]: () => {
    return {
      required: 'Please provide subject',
    };
  },
  [FIELDS_KEYS.message]: () => {
    return {
      required: 'Please provide message',
      minLength: {
        value: 5,
        message: 'Message length must be between 5 and 2147483647',
      },
      maxLength: {
        value: 2147483647,
        message: 'Message length must be between 5 and 2147483647',
      },
    };
  },
  [FIELDS_KEYS.tradeName]: (options) => {
    return {
      required: 'Please provide Business Name',
      pattern: {
        value: /^[ a-zA-Z0-9&-]+$/i,
        message:
          'The only punctuation and special characters allowed are hyphen (-) and ampersand (&)',
      },
      validate: validateTradeName(options),
    };
  },
  [FIELDS_KEYS.legalName]: (options) => {
    return {
      required: 'Please provide Business Name',
      pattern: {
        value: /^[ a-zA-Z0-9&-]+$/i,
        message:
          'The only punctuation and special characters allowed are hyphen (-) and ampersand (&)',
      },
      validate: validateLLCLegalName(options),
    };
  },
  [FIELDS_KEYS.altCompanyName]: (options) => {
    return {
      required: 'Please provide Alternate Business Name',
      pattern: {
        value: /^[ a-zA-Z0-9&-]+$/i,
        message:
          'The only punctuation and special characters allowed are hyphen (-) and ampersand (&)',
      },
      validate: validateAltCompanyName(options),
    };
  },
  [FIELDS_KEYS.designator]: () => {
    return {
      required: 'Please provide Designator',
    };
  },
  [FIELDS_KEYS.organizedState]: () => {
    return {
      required: 'Please select the state that you want to incorporate in',
    };
  },
  [FIELDS_KEYS.activityPrimaryActivity]: () => {
    return {
      required: 'Please select the business activity',
    };
  },
  [FIELDS_KEYS.productDescription]: (options) => {
    return {
      required: 'Please provide Product Description',
      pattern: {
        // value: /^[a-zA-Z][ a-zA-Z.\r\n]+{1,50}$/i,
        value: /^[ a-zA-Z.,\r\n]+$/i,
        message: 'Product Description should contain only letters',
      },
      maxLength: {
        value: 500,
        message: 'Product Description should be less or equal 500 symbols',
      },
      validate: validateProductDescription(options),
    };
  },
  [FIELDS_KEYS.activitySpecificProducts]: () => {
    return {
      required: 'Please select the specific products/services of the business',
    };
  },
  [FIELDS_KEYS.productExtraQuestion]: () => {
    return {
      required: 'Please select',
    };
  },
  [FIELDS_KEYS.physicalAddressAddress]: (options) => {
    return {
      required: 'Please provide Address',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z0-9\\/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z0-9\\/-]+$/i,
        message: 'Address should contain only letters, numbers, dash or slash',
      },
      maxLength: {
        value: 30,
        message: 'Address should be less or equal 30 symbols',
      },
      validate: validateAddress(options),
    };
  },
  [FIELDS_KEYS.physicalAddressAddress2]: (options) => {
    return {
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z0-9\\/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z0-9\\/-]+$/i,
        message: 'Address should contain only letters, numbers, dash or slash',
      },
      maxLength: {
        value: 30,
        message: 'Address should be less or equal 30 symbols',
      },
      validate: validateAddress(options),
    };
  },
  [FIELDS_KEYS.physicalAddressCity]: () => {
    return {
      required: 'Please provide City Name',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z/-]+$/i,
        message: 'City name should contain only letters and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'City name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.physicalAddressCounty]: () => {
    return {
      required: 'Please provide County Name',
      pattern: {
        value: /^[ a-zA-Z/-]+$/i,
        message: 'County name should contain only letters and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'County name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.physicalAddressState]: () => {
    return {
      required: 'Please select a State/Province',
    };
  },
  [FIELDS_KEYS.physicalAddressZip]: () => {
    return {
      required: 'Please provide a zip code',
      pattern: {
        value: /[0-9]/i,
        message: 'Zip should contain only digits',
      },
      minLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
      maxLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
    };
  },
  [FIELDS_KEYS.mailingAddressAddress]: (options) => {
    return {
      required: 'Please provide Address',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z0-9\\/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z0-9\\/-]+$/i,
        message: 'Address should contain only letters, numbers, dash or slash',
      },
      maxLength: {
        value: 30,
        message: 'Address should be less or equal 30 symbols',
      },
      validate: validateAddress(options),
    };
  },
  [FIELDS_KEYS.mailingAddressAddress2]: (options) => {
    return {
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z0-9\\/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z0-9\\/-]+$/i,
        message: 'Address should contain only letters, numbers, dash or slash',
      },
      maxLength: {
        value: 30,
        message: 'Address should be less or equal 30 symbols',
      },
      validate: validateAddress(options),
    };
  },
  [FIELDS_KEYS.mailingAddressCity]: () => {
    return {
      required: 'Please provide City Name',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z/-]+$/i,
        message: 'City name should contain only letters and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'City name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.mailingAddressCounty]: () => {
    return {
      required: 'Please provide County Name',
      pattern: {
        value: /^[ a-zA-Z/-]+$/i,
        message: 'County name should contain only letters and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'County name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.mailingAddressState]: () => {
    return {
      required: 'Please select a State/Province',
    };
  },
  [FIELDS_KEYS.mailingAddressZip]: () => {
    return {
      required: 'Please provide a zip code',
      pattern: {
        value: /[0-9]/i,
        message: 'Zip should contain only digits',
      },
      minLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
      maxLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
    };
  },
  [FIELDS_KEYS.name]: (options) => {
    return {
      required: 'Please provide Full Name',
      maxLength: {
        value: 90,
        message: 'Full Name should be less or equal 90 symbols',
      },
      validate: validateFullName(options),
    };
  },
  [FIELDS_KEYS.cardNumber]: (options) => {
    return {
      required: 'Please provide Card Number',
      validate: validateCardNumber(options),
    };
  },
  [FIELDS_KEYS.cvc]: (options) => {
    return {
      required: 'Please provide CVC/CVV',
      pattern: {
        value: /[0-9]/i,
        message: 'CVC/CVV should contain only digits',
      },
      minLength: {
        value: 3,
        message: 'CVC/CVV should contain 3 or 4 digits',
      },
      maxLength: {
        value: 4,
        message: 'CVC/CVV should contain 3 or 4 digits',
      },
      validate: validateCVC(options),
    };
  },
  [FIELDS_KEYS.cardMonth]: (options) => {
    return {
      required: 'Please enter Month',
      validate: validateCardMonth(options),
    };
  },
  [FIELDS_KEYS.cardYear]: (options) => {
    return {
      required: 'Please enter Year',
      validate: validateCardYear(options),
    };
  },
  [FIELDS_KEYS.firstName]: () => {
    return {
      required: 'Please provide First Name',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z\\&-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Firs Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'First Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.middleName]: () => {
    return {
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z\\&-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Middle Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Middle Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.lastName]: () => {
    return {
      required: 'Please provide Last Name',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z\\&-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z\\&-]+$/i,
        message: 'Last Name should contain only letters and & \\ - symbols',
      },
      maxLength: {
        value: 30,
        message: 'Last Name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.billingAddressAddress1]: (options) => {
    return {
      required: 'Please provide Billing Address',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z0-9\\/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z0-9\\/-]+$/i,
        message: 'Address should contain only letters, numbers, dash or slash',
      },
      maxLength: {
        value: 30,
        message: 'Address should be less or equal 30 symbols',
      },
      validate: validateAddress(options),
    };
  },
  [FIELDS_KEYS.billingAddressCity]: () => {
    return {
      required: 'Please provide City Name',
      pattern: {
        // value: /^(?! )(?!.* $)^[ a-zA-Z/-]+$/i,
        value: /^(?!\s*$)[ a-zA-Z/-]+$/i,
        message: 'City name should contain only letters and / - symbols',
      },
      maxLength: {
        value: 30,
        message: 'City name should be less or equal 30 symbols',
      },
    };
  },
  [FIELDS_KEYS.billingAddressState]: () => {
    return {
      required: 'Please select a State/Province',
    };
  },
  [FIELDS_KEYS.billingAddressZip]: () => {
    return {
      required: 'Please provide a zip code',
      pattern: {
        value: /[0-9]/i,
        message: 'Zip should contain only digits',
      },
      minLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
      maxLength: {
        value: 5,
        message: 'Zip should be equal 5 symbols',
      },
    };
  },
  [FIELDS_KEYS.agreeWithTerms]: () => {
    return {
      required: 'You must accept the terms and conditions to proceed',
    };
  },
  [FIELDS_KEYS.file]: (options) => {
    const { noValidate } = options || {};

    return {
      required: noValidate ? false : 'File is not chosen',
      validate: validateFile(options),
    };
  },
  [FIELDS_KEYS.dateOfBirthDay]: (options) => {
    const { noValidate } = options || {};

    return {
      required: noValidate ? false : 'Please select Day',
    };
  },
  [FIELDS_KEYS.dateOfBirthMonth]: (options) => {
    const { noValidate } = options || {};

    return {
      required: noValidate ? false : 'Please select Month',
    };
  },
  [FIELDS_KEYS.dateOfBirthYear]: (options) => {
    const { noValidate } = options || {};

    return {
      required: noValidate ? false : 'Please select Year',
    };
  },
  [FIELDS_KEYS.ssn]: (options) => {
    const { noValidate } = options || {};

    return {
      required: noValidate ? false : 'Please provide SSN',
      validate: validateSSN(options),
    };
  },
  [FIELDS_KEYS.driverLicenceOrID]: (options) => {
    const { noValidate } = options || {};

    return {
      required: noValidate
        ? false
        : `Please provide Driver's License or ID Number`,
      validate: validateDriverLicenceOrID(options),
    };
  },
};

export const getValidationRules = (fieldKey, options = {}) => {
  const getFieldRule = RULES[fieldKey];
  return getFieldRule ? getFieldRule(options) : undefined;
};
